import React from 'react'

const traverse = (obj, acc = []) => {
  if (obj && obj.hasOwnProperty('code')) {
    if (obj.hasOwnProperty('child_codes') && obj.child_codes !== null) {
      if (obj.child_codes.length > 0) {
        let i
        for (i = 0; i < obj.child_codes.length; i++) {
          acc.unshift(obj.child_codes[i].code)
        }
      }
    }
    if (!obj.hasOwnProperty('parent_code') || obj.parent_code === null) {
      acc.push(obj.code)
      return acc
    }
    acc.push(obj.code)
    return traverse(obj.parent_code, acc)
  }
}

const AccessCodeLineage = (props) => {
  if (props && props.hasOwnProperty('lineageData') && props.lineageData !== null) {
    const tempCodes = traverse(props.lineageData)
    let codes = []
    if ((tempCodes !== null) & (tempCodes !== undefined) && tempCodes.length > 0) {
      codes = tempCodes.reverse()
    }
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
          <h5>Access Code Lineage</h5>
        </div>
        <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
          {codes.length > 0 &&
            codes.map((code, i) => (
              <span key={code}>
                {' '}
                {i !== 0 && <i className='fa fa-arrow-right' />} <div className='badge badge-info'> {code} </div>
              </span>
            ))}
        </div>
      </div>
    )
  }
  return null
}

export default AccessCodeLineage
